import { Button, Chip, CloseIcon, Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePreviousSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { InheritClassesForm } from '../Forms/InheritClassesForm';
import styles from './InheritClassesModal.module.scss';

type InheritClassesModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const InheritClassesModal = ({ isOpen, onClose }: InheritClassesModalProps) => {
  const { t } = useTranslation();
  const previousSchoolYear = usePreviousSchoolYear();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      className={styles['inherit-classes-modal']}
      width='l'
      customHeader={
        <div className={styles.header}>
          <div className={styles.title}>{t('common.inheritFromPreviousYear')}</div>
          {previousSchoolYear && <Chip className={styles.chip} value={previousSchoolYear.shortName} />}
          <Button className={styles.button} hierarchy='tertiary' icon={<CloseIcon />} onClick={onClose} />
        </div>
      }
      loading={isLoading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <InheritClassesForm onLoad={setIsLoading} onClose={onClose} />
    </Modal>
  );
};
